import React, { useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { PrinterOutlined, ArrowLeftOutlined, DownloadOutlined } from "@ant-design/icons";
import { App, Button, Card, Flex, Grid, Typography } from "antd";
import { useNavigate } from "react-router-dom";
import AdvanceCreditorFilters from "./components/AdvanceCreditorFilters";
import AdvanceCreditorTable from "./components/AdvanceCreditorTable";
import ReportDom from "../../../components/common/ReportDom";
import { useReactToPrint } from "react-to-print";
import { resetData } from "./AdvanceCreditorSlice";
import { exportAdvanceCreditorCsv } from "./components/exportAdvanceCreditorCsv";

const { Title } = Typography;

const AdvanceCreditor = () => {
  const dispatch = useDispatch();
  const { message } = App.useApp();
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const authInfo  = useSelector((state) => state.authInfo);
  const { filters, list, totals } = useSelector((state) => state.advanceCreditor);
  const navigate = useNavigate();

  const handleNavigateToReports = () => {
    navigate("/reports");
    dispatch(resetData());
  };

  const reportRef = useRef();
  const handlePrint = useReactToPrint({
    contentRef: reportRef,
    documentTitle: "Advance Creditor Balance Report",
    removeAfterPrint: true,
  });
 const handleDownloadCsv = () => {
    exportAdvanceCreditorCsv({
      list,
      totals,
      title:    "Advance Creditor/Supplier Balance Report",
      filename: "advance_creditor_balance",
    });
  };

  const hasData = list.length > 0;
  return (
    <div className="p-4">
      <App>
        <Card
          className="shadow-md rounded-xl mb-4"
          title={
            <div style={{ display: "flex", alignItems: "center" }}>
              <Button
                type="text"
                icon={<ArrowLeftOutlined />}
                onClick={handleNavigateToReports}
                style={{ marginRight: 8 }}
              />
              <Title level={4} style={{ margin: 0 }} className="reportBigTitle" >Advance Creditor/Supplier Balance Report</Title>
            </div>
          }
   extra={
            hasData && (
              <Flex gap={8}>
                <Button icon={<DownloadOutlined />} onClick={handleDownloadCsv}>
                  {!screens.xs && "CSV"}
                </Button>
                <Button type="primary" icon={<PrinterOutlined />} onClick={handlePrint}>
                  {!screens.xs && "Print"}
                </Button>
              </Flex>
            )
          }
          styles={{
            header: { borderBottom: "none", padding: "12px 16px" },
            body: { padding: 0 },
          }}
        />

        <AdvanceCreditorFilters messageApi={message} />

        {list.length > 0 && (
          <Card className="shadow-md rounded-xl">
            <AdvanceCreditorTable authInfo={authInfo} />
          </Card>
        )}
      </App>

      {/* Hidden print layout */}
      <div style={{ position: "absolute", top: "-9999px", left: "-9999px" }}>
        <ReportDom
          ref={reportRef}
          title="Advance Creditor/Supplier Balance Report"
          mode="report-page"
          filters={filters}
          renderTable={() => (
            <AdvanceCreditorTable printMode={true} authInfo={authInfo} />
          )}
        />
      </div>
    </div>
  );
};

export default AdvanceCreditor;